import React from 'react';

function gaming() {
	return (
		<div class="col-md-10">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
			<div class="game racing">
			<h3>Racing</h3>
			<p>ConDragon is the first DeFi + NFT + RPG game in the Conflux community. In the game, players can tame dinosaurs, build equipments, trade materials, team up to embark an adventure, and capture pets. Meanwhile, ConDragon NFTs can be traded and auctioned on the market, and in exchange for rewards from the game pool.
			</p>
			<a href="" class="yellowbtn">Play Game</a>
			</div>
			<div class="game car">
			<h3>Car Racing</h3>
			<p>ConHero is the first RTS Mining game in the Conflux ecosystem. Players can use NFT to fight, Rank, and participate in PK competitions in the game. Players can also use ConHero NFT to stake mining and open treasure boxes. At the same time, the HeroNFT blind box event has been officially opened at UTC 10AM, 04/09/2021. Join the event to earn Limited HeroNFT.
			</p>
			<a href="" class="yellowbtn">Play Game</a>
			</div>
		</div>
	);
}

export default gaming;
			